import { render, staticRenderFns } from "./vipActivation.vue?vue&type=template&id=573d29fa&scoped=true&"
import script from "./vipActivation.vue?vue&type=script&lang=js&"
export * from "./vipActivation.vue?vue&type=script&lang=js&"
import style0 from "./vipActivation.vue?vue&type=style&index=0&id=573d29fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d29fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573d29fa')) {
      api.createRecord('573d29fa', component.options)
    } else {
      api.reload('573d29fa', component.options)
    }
    module.hot.accept("./vipActivation.vue?vue&type=template&id=573d29fa&scoped=true&", function () {
      api.rerender('573d29fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/vipActivation.vue"
export default component.exports